import $ from "jquery";
import { trapFocus, trapFocusRemove } from "./focus-trap.js";
//(function (global, $) {
//  "use strict";
//  var mobileBreakpoint = 568;
//  /**
//   * Sets up the mobile nav with the 'menu' button
//   */
//  function nav() {
//    $("#menu").on("click", function () {
//      if ($("#navigation").css("display") !== "none") {
//        $("#navigation").slideUp();
//      } else {
//        $("#navigation").slideDown();
//      }
//    });
//
//    $(global).on("resize", function () {
//      if ($(global).width() > mobileBreakpoint) {
//        $("#navigation").attr("style", "");
//      }
//    });
//  }
//
//  $(function () {
//    nav(); // mobile nav
//  });
//})(window, $);

var mq = window.matchMedia('(min-width: 960px');

function getMenuBtn() {
  return document.getElementById('menu');
}

function closeNav(button) {
  button.setAttribute('aria-expanded', 'false');
  document.documentElement.classList.remove('js-nav-open');
}

function escape() {
  trapFocusRemove();
  closeNav(getMenuBtn());
}

function onClick(event) {
  var button = event.currentTarget;
  var isOpen = button.getAttribute('aria-expanded');
  if (isOpen === 'true') {
    // close
    closeNav(button);
    trapFocusRemove();
  } else {
    // open
    button.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('js-nav-open');
    var nav = document.getElementById('navigation');
    var focusable = nav.querySelectorAll('a, input, button');
    if (focusable) {
      trapFocus(button, focusable[focusable.length - 1], escape);
    }
  }
}

// new 2023 nav code here
$(function () {
  var button = getMenuBtn();
  button.addEventListener('click', onClick);
  mq.addEventListener('change', event => {
    if (event.matches) {
      closeNav(button);
    }
  });
});

